import React from 'react';
import type { Tone } from '../../lib/classes';

const TONES: Record<Tone, string> = {
  stone:   'bg-stone-100 text-stone-700',
  indigo:  'bg-indigo-50 text-indigo-700',
  emerald: 'bg-emerald-50 text-emerald-700',
  amber:   'bg-amber-50 text-amber-800',
  rose:    'bg-rose-50 text-rose-700',
  violet:  'bg-indigo-50 text-indigo-700',
};

/** Status chip. Rounded rectangle, sentence case. */
export const Badge: React.FC<{ tone?: Tone; children: React.ReactNode; className?: string; title?: string }> = ({
  tone = 'stone', children, className = '', title,
}) => (
  <span title={title} className={`inline-flex items-center rounded px-1.5 py-0.5 text-[11.5px] font-medium whitespace-nowrap ${TONES[tone]} ${className}`}>
    {children}
  </span>
);
